/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CertificatesListParams,
  PaginatedCertificateList
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCertificatesListUrl = (params?: CertificatesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/certificates/?${stringifiedParams}` : `/api/certificates/`
}

/**
 * Represents Gigpro certified pro qualifications.
 */
export const certificatesList = async (params?: CertificatesListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedCertificateList> => {

  return customFetch<PaginatedCertificateList>(getCertificatesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCertificatesListInfiniteQueryKey = (params?: CertificatesListParams,) => {
    return [
    'infinite', `/api/certificates/`, ...(params ? [params] : [])
    ] as const;
    }

export const getCertificatesListQueryKey = (params?: CertificatesListParams,) => {
    return [
    `/api/certificates/`, ...(params ? [params] : [])
    ] as const;
    }


export const getCertificatesListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof certificatesList>>, CertificatesListParams['page']>, TError = void>(params?: CertificatesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof certificatesList>>, TError, TData, QueryKey, CertificatesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCertificatesListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof certificatesList>>, QueryKey, CertificatesListParams['page']> = ({ signal, pageParam }) => certificatesList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof certificatesList>>, TError, TData, QueryKey, CertificatesListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CertificatesListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof certificatesList>>>
export type CertificatesListInfiniteQueryError = void


export function useCertificatesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof certificatesList>>, CertificatesListParams['page']>, TError = void>(
 params: undefined |  CertificatesListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof certificatesList>>, TError, TData, QueryKey, CertificatesListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof certificatesList>>,
          TError,
          Awaited<ReturnType<typeof certificatesList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCertificatesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof certificatesList>>, CertificatesListParams['page']>, TError = void>(
 params?: CertificatesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof certificatesList>>, TError, TData, QueryKey, CertificatesListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof certificatesList>>,
          TError,
          Awaited<ReturnType<typeof certificatesList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCertificatesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof certificatesList>>, CertificatesListParams['page']>, TError = void>(
 params?: CertificatesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof certificatesList>>, TError, TData, QueryKey, CertificatesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCertificatesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof certificatesList>>, CertificatesListParams['page']>, TError = void>(
 params?: CertificatesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof certificatesList>>, TError, TData, QueryKey, CertificatesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCertificatesListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCertificatesListQueryOptions = <TData = Awaited<ReturnType<typeof certificatesList>>, TError = void>(params?: CertificatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof certificatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCertificatesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof certificatesList>>> = ({ signal }) => certificatesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof certificatesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CertificatesListQueryResult = NonNullable<Awaited<ReturnType<typeof certificatesList>>>
export type CertificatesListQueryError = void


export function useCertificatesList<TData = Awaited<ReturnType<typeof certificatesList>>, TError = void>(
 params: undefined |  CertificatesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof certificatesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof certificatesList>>,
          TError,
          Awaited<ReturnType<typeof certificatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCertificatesList<TData = Awaited<ReturnType<typeof certificatesList>>, TError = void>(
 params?: CertificatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof certificatesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof certificatesList>>,
          TError,
          Awaited<ReturnType<typeof certificatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCertificatesList<TData = Awaited<ReturnType<typeof certificatesList>>, TError = void>(
 params?: CertificatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof certificatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCertificatesList<TData = Awaited<ReturnType<typeof certificatesList>>, TError = void>(
 params?: CertificatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof certificatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCertificatesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






